import styled, { css } from 'styled-components';

const variants = {
  primary: css`
    background: ${({ theme }) => theme.colors.gold};
    color: ${({ theme }) => theme.colors.text};

    &:hover:not(:disabled) {
      background: ${({ theme }) => theme.colors.pinkSoft};
      transform: translateY(-3px);
      box-shadow: ${({ theme }) => theme.glow.gold};
    }
  `,
  dark: css`
    background: ${({ theme }) => theme.colors.bgDarker};
    color: #f4f3ee;

    &:hover:not(:disabled) {
      background: #33302a;
      transform: translateY(-3px);
      box-shadow: 0 10px 24px rgba(0, 0, 0, 0.28);
    }
  `,
  ghost: css`
    background: transparent;
    color: ${({ theme }) => theme.colors.text};
    border: 2px solid ${({ theme }) => theme.colors.text};

    &:hover:not(:disabled) {
      background: ${({ theme }) => theme.colors.gold};
      border-color: ${({ theme }) => theme.colors.gold};
      transform: translateY(-3px);
    }
  `,
  danger: css`
    background: transparent;
    color: ${({ theme }) => theme.colors.red};
    border: 2px solid ${({ theme }) => theme.colors.red};

    &:hover:not(:disabled) {
      background: rgba(192, 57, 43, 0.08);
    }
  `
};

// Alias para compatibilidad: $variant="gold" usa el estilo oscuro.
variants.gold = variants.dark;

const Button = styled.button.attrs(({ type }) => ({
  type: type || 'button'
}))`
  position: relative;
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5em;
  min-height: 44px;
  padding: 0.8em 2em;
  border-radius: ${({ theme }) => theme.radii.sm};
  font-family: ${({ theme }) => theme.fonts.heading};
  font-weight: 700;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  cursor: pointer;
  transition: transform 280ms cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 280ms ease,
    background 200ms ease;

  /* Destello diagonal que cruza el botón al pasar el mouse */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -60%;
    width: 40%;
    height: 100%;
    background: rgba(255, 255, 255, 0.35);
    transform: skewX(-20deg);
    transition: left 550ms ease;
    pointer-events: none;
  }

  &:hover::before {
    left: 130%;
  }

  ${({ $variant }) => variants[$variant] || variants.primary}

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;

    &::before {
      display: none;
    }
  }
`;

export default Button;
